import React from "react";

const Privacy = () => {
  return (
    <div
      className=" lg:w-[920px] w-[353px] mx-auto  flex flex-col gap-14 lg:py-32 py-24 justify-center items-center"
      id="privacy"
    >
      <div className="flex flex-col gap-14 ">
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            1. INTRODUCTION
          </h3>
          <p className="text-base leading-6">
            <strong>1.1</strong> Flashport Technologies Private Limited
            ("Flashport," "Flit App," “Flit Rider App,” "we," "us," or "our") is
            committed to protecting your privacy and ensuring the security of
            your personal information. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information when you
            access our website, mobile application, or use any of our services
            under the brand name "Flit".
            <br />
            <strong>1.2</strong> By accessing or using our services, you consent
            to the collection, use, and disclosure of your information as
            described in this Privacy Policy. If you do not agree with our
            policies and practices, please do not use our services.
            <br />
            <strong>1.3</strong> This Privacy Policy is an electronic record
            under the Information Technology Act, 2000, and the rules made
            thereunder. This electronic record is generated by a computer system
            and does not require any physical or digital signatures.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            2. INFORMATION WE COLLECT
          </h3>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  2.1 Information You Provide to Us
                </h3>
                We may collect the following types of information that you
                voluntarily provide to us:
              </div>
              <p>
                <strong>2.1.1</strong> Account Information: Name, email address,
                phone number, and password.
                <br />
                <strong>2.1.2</strong> Profile Information: Profile picture,
                address, and preferences.
                <br />
                <strong>2.1.3</strong> Transaction Information: Shipments,
                pickups, deliveries, payment methods, and transaction history.
                <br />
                <strong>2.1.4</strong> Communication Information: Customer
                support messages and responses.
                <br />
                <strong>2.1.5</strong> Feedback and Reviews: Surveys,
                promotions, and service reviews.
                <br />
                <strong>2.1.6</strong> KYC Information: Identity verification
                documents (PAN card, address proof, etc.).
                <br />
                <strong>2.1.7</strong> Employment and Business Information:
                Employment history, skillset, and business details.
                <br />
                <strong>2.1.8</strong> Biometric Information: Facial
                recognition, fingerprints (for security purposes).
                <br />
                <strong>2.1.9</strong> Referral Information: Contact details of
                referred individuals.
                <br />
                <strong>2.1.10</strong> Emergency Contact Information: Details
                for use in emergencies.
                <br />
                <strong>2.1.11</strong> Insurance Information: Accident reports,
                medical information, property damage assessments.
                <br />
                <strong>2.1.12</strong> Payment Information: Bank details,
                credit/debit card info, UPI IDs.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                2.2 Information We Collect Automatically
              </h3>
              <p>
                <strong>2.2.1</strong> Device Information: Type, OS, unique
                identifiers, IP address, mobile network details.
                <br />
                <strong>2.2.2</strong> Location Information: Real-time GPS data
                for tracking and delivery optimization.
                <br />
                <strong>2.2.3</strong> Usage Information: Clickstream data,
                interaction with features.
                <br />
                <strong>2.2.4</strong> Cookies and Similar Technologies: Data
                collection for usage analysis and preferences.
                <br />
                <strong>2.2.5</strong> SMS, Call, and Device Logs: (With
                permission) Used for service improvements.
                <br />
                <strong>2.2.6</strong> Camera and Microphone: (With permission)
                Package images, QR code scanning, support calls.
                <br />
                <strong>2.2.7</strong> Accelerometer and Gyroscope Data: Motion
                tracking for safety analysis.
                <br />
                <strong>2.2.8</strong> Battery Status: Used for uninterrupted
                service optimization.
                <br />
                <strong>2.2.9</strong> Network Information: Carrier details,
                signal strength.
                <br />
                <strong>2.2.10</strong> App Performance Data: Crash reports,
                errors, debug information.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                2.3 Information from Third Parties
              </h3>
              <p>
                <strong>2.3.1</strong> Business partners, service providers, and
                payment processors.
                <br />
                <strong>2.3.2</strong> Social media platforms when you connect
                or share content.
                <br />
                <strong>2.3.3</strong> Publicly available sources for identity
                verification.
                <br />
                <strong>2.3.4</strong> Credit bureaus and financial institutions
                for credit checks.
                <br />
                <strong>2.3.5</strong> References provided during the
                registration process.
                <br />
                <strong>2.3.6</strong> Insurance providers and claims
                processors.
                <br />
                <strong>2.3.7</strong> Government agencies for verification
                purposes.
                <br />
                <strong>2.3.8</strong> Other users who refer you to Flit
                services.
                <br />
                <strong>2.3.9</strong> Marketing and analytics partners for
                campaign effectiveness analysis.
              </p>
            </div>
          </p>
        </div>
        <div className="text-[#364763] flex flex-col gap-6">
          <h3 className="text-xl font-semibold text-[#131D2D]">
            3. HOW WE USE YOUR INFORMATION
          </h3>
          <p className="text-base leading-6">
            We use your information for various purposes, including to:
            <br />
            <strong>3.1</strong> Provide, maintain, and improve our Flit
            services.
            <br />
            <strong>3.2</strong> Process and fulfill your requests,
            transactions, and payments.
            <br />
            <strong>3.3</strong> Communicate with you about our services,
            updates, and promotions.
            <br />
            <strong>3.4</strong> Personalize your experience and deliver content
            tailored to your interests.
            <br />
            <strong>3.5</strong> Monitor and analyze usage patterns and trends
            to enhance our services.
            <br />
            <strong>3.6</strong> Detect, prevent, and address technical issues,
            fraud, and security breaches.
            <br />
            <strong>3.7</strong> Comply with legal obligations and enforce our
            terms and policies.
            <br />
            <strong>3.8</strong> Verify your identity and conduct background
            checks for service providers.
            <br />
            <strong>3.9</strong> Resolve disputes and troubleshoot problems.
            <br />
            <strong>3.10</strong> Conduct research and analysis to improve our
            business operations.
            <br />
            <strong>3.11</strong> Process employee and partner applications and
            manage relationships.
            <br />
            <strong>3.12</strong> Administer referral programs, loyalty rewards,
            and promotions.
            <br />
            <strong>3.13</strong> Provide emergency assistance when necessary.
            <br />
            <strong>3.14</strong> Process and assist with insurance claims.
            <br />
            <strong>3.15</strong> Develop new products, services, and features.
            <br />
            <strong>3.16</strong> Track and analyze ride statistics for partners
            to help improve earnings.
            <br />
            <strong>3.17</strong> Respond to requests from law enforcement
            agencies.
            <br />
            <strong>3.18</strong> Match you with appropriate service providers
            based on your location and requirements.
            <br />
            <strong>3.19</strong> Facilitate communication between users and
            service providers.
            <br />
            <strong>3.20</strong> Create and maintain a trusted and safe
            environment on our platform.
            <br />
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          <div>
            <h3 className="text-xl font-semibold text-[#131D2D]">
              4. HOW WE SHARE YOUR INFORMATION
            </h3>
            We may share your information in the following circumstances:
          </div>
          <p className="text-base leading-6 flex flex-col gap-3">
            <div className="flex flex-col gap-3">
              <div>
                <h3 className="text-lg font-semibold text-[#131D2D]">
                  4.1 Service Providers and Business Partners
                </h3>
                We may share your information with trusted third-party service
                providers and business partners who help us deliver our Flit
                services, including:
              </div>
              <p>
                <strong>4.1.1</strong> Payment processors and financial
                institutions.
                <br />
                <strong>4.1.2</strong> Cloud service providers and data storage
                providers.
                <br />
                <strong>4.1.3</strong> Customer support and communication
                services.
                <br />
                <strong>4.1.4</strong> Analytics and advertising partners.
                <br />
                <strong>4.1.5</strong> Delivery partners and logistics
                providers.
                <br />
                <strong>4.1.6</strong> Identity verification and background
                check providers.
                <br />
                <strong>4.1.7</strong> Insurance providers and claims
                processors.
                <br />
                <strong>4.1.8</strong> Professional advisors, including lawyers,
                accountants, and auditors.
                <br />
                <strong>4.1.9</strong> Marketing and promotional partners.
                <br />
                <strong>4.1.10</strong> Emergency services providers.
                <br />
                <strong>4.1.11</strong> Device and application manufacturers.
                <br />
                <strong>4.1.12</strong> Telecommunications operators.
                <br />
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.2 Legal Requirements
              </h3>
              <p>
                <strong>4.2.1</strong> We may disclose your information if
                required to do so by law or in response to valid requests by
                public authorities (e.g., a court, government agency, or law
                enforcement). This includes:
                <br />
                <strong>4.2.1.1</strong> Responding to legal processes, such as
                subpoenas, court orders, or search warrants.
                <br />
                <strong>4.2.1.2</strong> Protection against fraudulent,
                malicious, or illegal activity.
                <br />
                <strong>4.2.1.3</strong> Protecting the rights, property, or
                safety of Flashport, Flit, our users, or the public.
                <br />
                <strong>4.2.1.4</strong> Responding to national security or law
                enforcement requirements.
                <br />
                <strong>4.2.1.5</strong> Complying with applicable regulations
                and industry standards.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.3 Business Transfers
              </h3>
              <p>
                <strong>4.3.1</strong> If we are involved in a merger,
                acquisition, financing, reorganization, bankruptcy, or sale of
                all or a portion of our assets, your information may be
                transferred or disclosed as part of that transaction.
                <br />
                <strong>4.3.2</strong> We will notify you of any such change in
                ownership or control of your personal information.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.4 With Your Consent
              </h3>
              <p>
                <strong>4.4.1</strong> We may share your information with third
                parties when you have given us your consent to do so.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.5 Other Users and Public Information
              </h3>
              <p>
                <strong>4.5.1</strong> Certain features of our Flit services may
                display your information to other users or publicly, such as:
                <br />
                <strong>4.5.1.1</strong> Reviews and ratings you provide may be
                visible to other users.
                <br />
                <strong>4.5.1.2</strong> Delivery status, including pickup and
                drop-off locations, may be shared with senders and recipients.
                <br />
                <strong>4.5.1.3</strong> Profile information may be visible to
                other users of our services.
                <br />
                <strong>4.5.1.4</strong> Information shared in community forums
                or public features.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <h3 className="text-lg font-semibold text-[#131D2D]">
                4.6 Emergency Situations
              </h3>
              <p>
                <strong>4.6.1</strong> We may share your information, including
                your location and contact details, with emergency services (such
                as police, fire, or medical services) in the event of an
                emergency or if we believe it is necessary to protect your
                safety or the safety of others.
              </p>
            </div>
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          {/* Section 5: Communication Channels */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            5. COMMUNICATION CHANNELS
          </h3>
          <p className="text-base leading-6">
            <strong>5.1.</strong> We may communicate with you through various
            channels, including:
            <br />
            <strong>5.1.1.</strong> In-app notifications and messages.
            <br />
            <strong>5.1.2.</strong> Email.
            <br />
            <strong>5.1.3.</strong> SMS.
            <br />
            <strong>5.1.4.</strong> WhatsApp and other messaging platforms.
            <br />
            <strong>5.1.5.</strong> Phone calls.
            <br />
            <strong>5.1.6.</strong> Push notifications.
            <br />
            <strong>5.2.</strong> You can manage your communication preferences
            through your account settings, but you may not opt out of essential
            service-related communications.
          </p>

          {/* Section 6: Your Choices and Rights */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            6. YOUR CHOICES AND RIGHTS
          </h3>
          <p className="text-base leading-6">
            <strong>6.1.</strong> <strong>Your Choices</strong>
            <br />
            You have certain choices regarding your information:
            <br />
            <strong>6.1.1.</strong> Account Information: You can review and
            update your Flit account information by logging into your account.
            <br />
            <strong>6.1.2.</strong> Communication Preferences: You can opt out
            of receiving promotional communications by following the unsubscribe
            instructions included in these communications. However, you cannot
            opt out of receiving service-related messages that are essential to
            providing our services.
            <br />
            <strong>6.1.3.</strong> Location Information: You can modify your
            device settings to disable location sharing, but this may limit
            certain features of our services or make them unavailable.
            <br />
            <strong>6.1.4.</strong> Cookies: You can set your browser to refuse
            all or some browser cookies or to alert you when cookies are being
            sent.
            <br />
            <strong>6.1.5.</strong> Mobile App Permissions: You can modify your
            device settings to disable access to device features like camera,
            contacts, or microphone.
            <br />
            <strong>6.1.6.</strong> Referral Programs: You can choose not to
            participate in our referral programs or loyalty rewards programs.
            <br />
            <br />
            <strong>6.2.</strong> <strong>Your Data Protection Rights</strong>
            <br />
            Depending on applicable laws, you may have the right to:
            <br />
            <strong>6.2.1.</strong> Access the personal information we hold
            about you.
            <br />
            <strong>6.2.2.</strong> Correct inaccurate or incomplete
            information.
            <br />
            <strong>6.2.3.</strong> Request deletion of your personal
            information.
            <br />
            <strong>6.2.4.</strong> Restrict or object to the processing of your
            information.
            <br />
            <strong>6.2.5.</strong> Request the transfer of your information to
            another entity.
            <br />
            <strong>6.2.6.</strong> Withdraw consent where we rely on consent to
            process your information.
            <br />
            <strong>6.2.7.</strong> Lodge a complaint with a supervisory
            authority.
            <br />
            <strong>6.3.</strong> To exercise any of these rights, please
            contact us using the information provided at the end of this policy.
            We may need to verify your identity before fulfilling your request.
          </p>

          {/* Section 7: Data Security */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            7. DATA SECURITY
          </h3>
          <p className="text-base leading-6">
            <strong>7.1.</strong> We implement appropriate technical and
            organizational measures to protect your information against
            unauthorized access, alteration, disclosure, or destruction. These
            measures include:
            <br />
            <strong>7.1.1.</strong> Encryption of sensitive information.
            <br />
            <strong>7.1.2.</strong> Regular security assessments and
            vulnerability testing.
            <br />
            <strong>7.1.3.</strong> Access controls and authentication
            mechanisms.
            <br />
            <strong>7.1.4.</strong> Employee training on data security
            practices.
            <br />
            <strong>7.1.5.</strong> Physical security measures at our
            facilities.
            <br />
            <strong>7.1.6.</strong> Regular backups and data recovery
            procedures.
            <br />
            <strong>7.1.7.</strong> Incident response plans.
            <br />
            <strong>7.1.8.</strong> Compliance with industry security standards.
            <br />
            <strong>7.2.</strong> However, no method of transmission over the
            Internet or electronic storage is 100% secure, and we cannot
            guarantee absolute security.
            <br />
            <strong>7.3.</strong> You are responsible for maintaining the
            confidentiality of your Flit account credentials and for any
            activities that occur under your account.
          </p>

          {/* Section 8: Data Retention */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            8. DATA RETENTION
          </h3>
          <p className="text-base leading-6">
            <strong>8.1.</strong> We retain your information for as long as
            necessary to fulfill the purposes outlined in this Privacy Policy,
            unless a longer retention period is required or permitted by law.
            <br />
            <strong>8.2.</strong> When determining retention periods, we
            consider:
            <br />
            <strong>8.2.1.</strong> The amount, nature, and sensitivity of the
            information.
            <br />
            <strong>8.2.2.</strong> The potential risk of harm from unauthorized
            use or disclosure.
            <br />
            <strong>8.2.3.</strong> The purposes for which we process your
            information.
            <br />
            <strong>8.2.4.</strong> Applicable legal requirements and statutory
            retention periods.
            <br />
            <strong>8.2.5.</strong> The need to resolve disputes and enforce our
            agreements.
            <br />
            <strong>8.3.</strong> When we no longer need your information, we
            will securely delete or anonymize it in accordance with our data
            retention policies.
          </p>

          {/* Section 9: Rewards and Loyalty Programs */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            9. REWARDS AND LOYALTY PROGRAMS
          </h3>
          <p className="text-base leading-6">
            <strong>9.1.</strong> We may offer rewards, cashback, loyalty
            programs, or other promotional offers.
            <br />
            <strong>9.2.</strong> Participation in these programs may involve
            the collection and processing of additional information, such as:
            <br />
            <strong>9.2.1.</strong> Transaction history.
            <br />
            <strong>9.2.2.</strong> Redemption of rewards.
            <br />
            <strong>9.2.3.</strong> Program preferences.
            <br />
            <strong>9.2.4.</strong> Points or credits earned and redeemed.
            <br />
            <strong>9.3.</strong> This information will be used to:
            <br />
            <strong>9.3.1.</strong> Administer the programs.
            <br />
            <strong>9.3.2.</strong> Track your eligibility for rewards.
            <br />
            <strong>9.3.3.</strong> Provide you with relevant offers and
            benefits.
            <br />
            <strong>9.3.4.</strong> Analyze program effectiveness.
          </p>
        </div>

        <div className="text-[#364763] flex flex-col gap-6">
          {/* Section 10: Cross-Border Transfers */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            10. CROSS-BORDER TRANSFERS
          </h3>
          <p className="text-base leading-6">
            <strong>10.1.</strong> We may transfer, store, and process your
            information in countries other than your own. These countries may
            have data protection laws that are different from the laws of your
            country.
            <br />
            <strong>10.2.</strong> By using our Flit services, you consent to
            the transfer of your information to these countries.
            <br />
            <strong>10.3.</strong> We take appropriate safeguards to ensure that
            your information remains protected in accordance with this Privacy
            Policy, including:
            <br />
            <strong>10.3.1.</strong> Using standard contractual clauses approved
            by relevant authorities.
            <br />
            <strong>10.3.2.</strong> Ensuring third-party service providers
            maintain adequate data protection standards.
            <br />
            <strong>10.3.3.</strong> Implementing technical and organizational
            measures to protect your information.
            <br />
            <strong>10.3.4.</strong> Conducting assessments of data protection
            laws in recipient countries.
          </p>

          {/* Section 11: Children's Privacy */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            11. CHILDREN'S PRIVACY
          </h3>
          <p className="text-base leading-6">
            <strong>11.1.</strong> Our Flit services are not intended for
            children under 18 years of age, and we do not knowingly collect
            personal information from children.
            <br />
            <strong>11.2.</strong> If we learn that we have collected personal
            information from a child without parental consent, we will take
            steps to delete that information as soon as possible.
            <br />
            <strong>11.3.</strong> If you are a parent or guardian and believe
            that your child has provided us with personal information, please
            contact us immediately.
          </p>

          {/* Section 12: Third-Party Links and Services */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            12. THIRD-PARTY LINKS AND SERVICES
          </h3>
          <p className="text-base leading-6">
            <strong>12.1.</strong> Our Flit services may contain links to
            third-party websites, applications, or services.
            <br />
            <strong>12.2.</strong> We are not responsible for the privacy
            practices or content of these third parties.
            <br />
            <strong>12.3.</strong> We encourage you to review the privacy
            policies of any third-party sites or services before providing any
            information to them.
          </p>

          {/* Section 13: Changes to Privacy Policy */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            13. CHANGES TO THIS PRIVACY POLICY
          </h3>
          <p className="text-base leading-6">
            <strong>13.1.</strong> We may update this Privacy Policy from time
            to time to reflect changes in our practices or for other
            operational, legal, or regulatory reasons.
            <br />
            <strong>13.2.</strong> We will notify you of any material changes
            by:
            <br />
            <strong>13.2.1.</strong> Posting the new Privacy Policy on this
            page.
            <br />
            <strong>13.2.2.</strong> Updating the "Last Updated" date at the top
            of this page.
            <br />
            <strong>13.2.3.</strong> Sending an email or providing a
            notification through our Flit services.
            <br />
            <strong>13.3.</strong> The revised policy will be effective
            immediately for new users and from the notification date for
            existing users.
            <br />
            <strong>13.4.</strong> We encourage you to review this Privacy
            Policy periodically to stay informed about how we protect your
            information.
          </p>

          {/* Section 14: Consent to Electronic Communications */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            14. CONSENT TO ELECTRONIC COMMUNICATIONS
          </h3>
          <p className="text-base leading-6">
            <strong>14.1.</strong> By using our Flit services, you consent to
            receive communications from us electronically, including:
            <br />
            <strong>14.1.1.</strong> Emails.
            <br />
            <strong>14.1.2.</strong> Text messages.
            <br />
            <strong>14.1.3.</strong> WhatsApp messages.
            <br />
            <strong>14.1.4.</strong> Push notifications.
            <br />
            <strong>14.1.5.</strong> In-app messages.
            <br />
          </p>

          {/* Section 15: Cookies and Tracking Technologies */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            15. COOKIES AND TRACKING TECHNOLOGIES
          </h3>
          <p className="text-base leading-6">
            <strong>15.1.</strong> We use cookies and similar tracking
            technologies to track activity on our services and to hold certain
            information.
            <br />
            <strong>15.2.</strong> Types of cookies we use:
            <br />
            <strong>15.2.1.</strong> Essential Cookies: Necessary for the
            operation of our services.
            <br />
            <strong>15.2.2.</strong> Analytical/Performance Cookies: Allow us to
            recognize and count visitors and analyze how users navigate our
            services.
            <br />
            <strong>15.2.3.</strong> Functionality Cookies: Enable us to
            personalize content and remember your preferences.
            <br />
            <strong>15.2.4.</strong> Targeting/Advertising Cookies: Record your
            visit to our services, the pages you have visited, and the links you
            have followed to deliver more relevant advertisements.
          </p>

          {/* Section 16: Social Media Integration */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            16. SOCIAL MEDIA INTEGRATION
          </h3>
          <p className="text-base leading-6">
            <strong>16.1.</strong> Our services may include social media
            features, such as the Facebook Like button, or widgets such as the
            Share button.
            <br />
            <strong>16.2.</strong> These features may collect your IP address,
            which page you are visiting on our services, and may set a cookie to
            enable the feature to function properly.
          </p>

          {/* Section 17: Marketing and Advertising */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            17. MARKETING AND ADVERTISING
          </h3>
          <p className="text-base leading-6">
            <strong>17.1.</strong> We may use your information to provide you
            with targeted advertisements or marketing communications we believe
            may be of interest to you.
          </p>

          {/* Section 18: Governing Law and Dispute Resolution */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            18. GOVERNING LAW AND DISPUTE RESOLUTION
          </h3>
          <p className="text-base leading-6">
            <strong>18.1.</strong> This Privacy Policy shall be governed by and
            construed in accordance with the laws of India.
            <br />
            <strong>18.2.</strong> Any dispute arising out of or in connection
            with this policy shall be subject to the exclusive jurisdiction of
            the courts in Bihar, India.
          </p>

          {/* Section 19: Indemnification */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            19. INDEMNIFICATION
          </h3>
          <p className="text-base leading-6">
            <strong>19.1.</strong> You agree to indemnify, defend, and hold
            harmless Flashport Technologies Private Limited (Flit) from any
            claims, liabilities, damages, or losses.
          </p>

          {/* Section 20: Contact Us */}
          {/* Section 20: Contact Us */}
          <h3 className="text-xl font-semibold text-[#131D2D]">
            20. CONTACT US
          </h3>
          <p className="text-base leading-6">
            <strong>20.1.</strong> If you have any questions, concerns, or
            requests regarding this Privacy Policy or our privacy practices,
            please contact us at:
          </p>
          <div className="mt-2">
            <p className="text-base">
              <strong>Flashport Technologies Private Limited (Flit)</strong>
            </p>
            <p className="text-base">
              346B, SHIV SADAN, MANGALAM, VIHAR COLONY, JAGDEO PATH, Patna
              Aerodrome, Phulwari, Patna- 800014, Bihar
            </p>
            <p className="text-base">
              <strong>Email:</strong>{" "}
              <a href="mailto:support@goflash.in" className="text-blue-500">
                support@goflash.in
              </a>
            </p>
            <p className="text-base">
              <strong>Phone:</strong>{" "}
              <a href="tel:+917045063838" className="text-blue-500">
                +91 70450 63838
              </a>
            </p>
            <p className="text-base">
              <strong>Website:</strong>{" "}
              <a
                href="https://www.goflit.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500"
              >
                www.goflit.in
              </a>
            </p>
          </div>

          {/* Section 21: Grievance Officer */}
          <h3 className="text-xl font-semibold text-[#131D2D] mt-6">
            21. GRIEVANCE OFFICER
          </h3>
          <p className="text-base leading-6">
            <strong>21.1.</strong> In compliance with the Information Technology
            Act, 2000 and the rules made thereunder, we have appointed a
            Grievance Officer to address any grievances or concerns you may have
            regarding our privacy practices:
          </p>
          <div className="mt-2">
            <p className="text-base">
              <strong>Parikshit Bhanushali</strong>
            </p>
            <p className="text-base">
              <strong>Email:</strong>{" "}
              <a href="mailto:support@goflash.in" className="text-blue-500">
                support@goflash.in
              </a>
            </p>
            <p className="text-base">
              <strong>Phone:</strong>{" "}
              <a href="tel:+917045063838" className="text-blue-500">
                +91 70450 63838
              </a>
            </p>
          </div>
          <p className="text-base leading-6 mt-2">
            <strong>21.2.</strong> The Grievance Officer will address your
            concerns and attempt to resolve them within 30 days of receiving
            your complaint.
          </p>
        </div>
        <p className="text-sm text-gray-500">Last Updated: 3rd March, 2025</p>
      </div>
    </div>
  );
};

export default Privacy;
